<script setup>
import { ref, computed, onMounted } from "vue";

import { useI18n } from "vue-i18n";

import SnsSelect from "@/components/ui/SnsSelect.vue";

const { t, locale: currentLocale } = useI18n();

const selectedLocale = ref({});
const languages = ref([
  { text: t("name.language.english"), value: "en" },
  { text: t("name.language.arabic"), value: "ar" },
  { text: t("name.language.german"), value: "de" },
  { text: t("name.language.spanish"), value: "es" },
  { text: t("name.language.french"), value: "fr" },
  { text: t("name.language.hindi"), value: "hi" },
  { text: t("name.language.indonesian"), value: "id" },
  { text: t("name.language.italian"), value: "it" },
  { text: t("name.language.japanese"), value: "ja" },
  { text: t("name.language.korean"), value: "ko" },
  { text: t("name.language.dutch"), value: "nl" },
  { text: t("name.language.russian"), value: "ru" },
  { text: t("name.language.turkish"), value: "tr" },
  { text: t("name.language.uzbek"), value: "uz" },
  { text: t("name.language.vietnamese"), value: "vn" },
  { text: t("name.language.chinese"), value: "zh" },
  { text: t("name.language.ukrainian"), value: "uk" },
  { text: t("name.language.thai"), value: "th" },
  { text: t("name.language.chineseTraditional"), value: "zh-TW" },
  { text: t("name.language.portuguese"), value: "pt" },
]);

const canSave = computed(() => {
  return selectedLocale.value.value !== currentLocale.value;
});

const sortedLanguages = computed(() => {
  return [...languages.value].sort((a, b) => {
    if (a.value === selectedLocale.value.value) return -1;

    if (b.value === selectedLocale.value.value) return 1;

    if (a.value === "en") return -1;

    if (b.value === "en") return 1;

    return a.text.localeCompare(b.text);
  });
});

const save = () => {
  currentLocale.value = selectedLocale.value.value;
  localStorage.setItem("locale", selectedLocale.value.value);
  window.location.reload();
};

onMounted(() => {
  selectedLocale.value =
    languages.value.find((lang) => lang.value === currentLocale.value) ||
    languages.value.find((lang) => lang.value === "en") ||
    languages.value[0];
});

defineExpose({
  save,
  canSave,
});
</script>

<template>
  <div class="w-full">
    <SnsSelect v-model="selectedLocale" :items="sortedLanguages" />
  </div>
</template>
